module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/writable-browser.js
// module id = 2622
// module chunks = 2